import { ref } from 'vue';
import { useRoute } from 'vue-router';

// Module-level cache: survives navigation between assistant pages,
// resets on a full browser reload.
const store = new Map();
let currentScope = null;

// Pure core, exported for tests. Same (scope, key) -> same ref object.
// A new scope (account switch) wipes the cache so one account can never
// see another account's data.
export function getScopedRef(scope, key, defaultValue) {
  if (scope !== currentScope) {
    store.clear();
    currentScope = scope;
  }
  if (!store.has(key)) {
    store.set(key, ref(defaultValue));
  }
  return store.get(key);
}

// Component-facing wrapper. Must run inside setup() (uses useRoute).
export function usePersistentRef(key, defaultValue = null) {
  const route = useRoute();
  return getScopedRef(String(route.params.accountId), key, defaultValue);
}
